const SECURE_RANDOM_INT_DEFAULT = 999;

export const secureRandomInt = (max: number = SECURE_RANDOM_INT_DEFAULT): number => {
  const array = new Uint32Array(1);
  crypto.getRandomValues(array);
  return array[0] % max;
};

export const shuffleArray = <T>(array: readonly T[]): T[] => {
  const result: T[] = [ ...array ];
  for (let i = result.length - 1; i > 0; i -= 1) {
    const j = secureRandomInt(i + 1);
    [ result[i], result[j] ] = [ result[j], result[i] ];
  }
  return result;
};

export const LIST_FORMATTER = new Intl.ListFormat("en", {
  style: "long",
  type: "conjunction",
});

export const LIST_FORMATTER_SHORT = new Intl.ListFormat("en", {
  style: "short",
  type: "conjunction",
});

export const first = <T>(array: T[] | undefined): T | undefined => (array ? array[0] : undefined);
